import router from './router'
import store from './store'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css'// Progress 进度条样式
import { Message } from 'element-ui'
import { getToken } from '@/utils/auth'
import alert from "element-ui/packages/alert"; // 验权

const whiteList = ['/login','/register','/loginByPhone','/forgetPassword'] // 不重定向白名单
router.beforeEach((to, from, next) => {
  console.log('守卫触发，to:', to.path, 'token:', getToken())  // 添加
  NProgress.start()
  if (getToken()) {
    if (to.path === '/login'||to.path === '/loginByPhone') {
      console.log('已有token，但访问登录页，重定向到首页')
      next({ path: '/' })
      NProgress.done() // if current page is dashboard will not trigger	afterEach hook, so manually handle it
    } else {
      if (store.getters.roles.length === 0) {
        console.log('roles为空，开始获取用户信息')
        store.dispatch('GetInfo').then(res => { // 拉取用户信息
          console.log('GenerateRoutes成功，动态添加路由')
          let menus=res.data.menus;
          let username=res.data.username;
          store.dispatch('GenerateRoutes', { menus,username }).then(() => { // 生成可访问的路由表
            router.addRoutes(store.getters.addRouters); // 动态添加可访问路由表
            next({ ...to, replace: true })
          })
        }).catch((err) => {
          console.error('GenerateRoutes失败', err)  // 添加catch
          store.dispatch('FedLogOut').then(() => {
            Message.error(err || 'Verification failed, please login again')
            next({ path: '/' })
          })
        })
      } else {
        next()
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next('/login')
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done() // 结束Progress
})



// WEBPACK FOOTER //
// ./src/permission.js